<script>
import store from '@state/store'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import { Cropper } from 'vue-advanced-cropper'
import { validationMixin } from 'vuelidate'
import { required, not, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'UserEdit',
  components: {
    Tab,
    Tabs,
    Cropper,
  },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userName: this.user.name,
      userEmail: this.user.email,
      userPhone: this.user.phone,
      userCountryPrefix: this.user.country_prefix,
      userPhoto: this.user.image_url,
      editingName: false,
      editingEmail: false,
      editingPassword: false,
      toCropImage: false,
      visibleImageCropper: false,
      croppedImage: false,
      userCurrentPassword: '',
      userNewPassword: '',
      userConfirmNewPassword: '',
      goals: this.user.my_goals
        ? JSON.parse(JSON.stringify(this.user.my_goals))
        : [],
      saveButtonText: 'Save',
    }
  },
  validations: {
    userCurrentPassword: {
      required,
    },
    userNewPassword: {
      required,
      notCurrentPassword: not(sameAs('userCurrentPassword')),
    },
    userConfirmNewPassword: {
      required,
      sameAsNewPassword: sameAs('userNewPassword'),
    },
  },
  computed: {
    defaultCompany() {
      var found = false
      this.user.companies.forEach((company) => {
        if (this.user.default_company_id === company.id) {
          found = company
        }
      })
      return found
    },
    companies() {
      var companies = []
      this.user.companies.forEach((company) => {
        if (this.user.default_company_id !== company.id) {
          companies.push(company)
        }
      })
      return companies
    },
    volunteerGoal: {
      get: function() {
        var goal = 0
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'volunteered') {
            goal = this.goals[index].goal
          }
        }
        return goal
      },
      set: function(val) {
        this.$emit('input', val)
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'volunteered') {
            this.goals[index].goal = val
          }
        }
      },
    },
    donationGoal: {
      get: function() {
        var goal = 0
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'donation') {
            goal = this.goals[index].goal
          }
        }
        return goal
      },
      set: function(val) {
        this.$emit('input', val)
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'donation') {
            this.goals[index].goal = val
          }
        }
      },
    },
    kyndnessGoal: {
      get: function() {
        var goal = 0
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'kyndness') {
            goal = this.goals[index].goal
          }
        }
        return goal
      },
      set: function(val) {
        this.$emit('input', val)
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'kyndness') {
            this.goals[index].goal = val
          }
        }
      },
    },
    gratitudeGoal: {
      get: function() {
        var goal = 0
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'gratitude') {
            goal = this.goals[index].goal
          }
        }
        return goal
      },
      set: function(val) {
        this.$emit('input', val)
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'gratitude') {
            this.goals[index].goal = val
          }
        }
      },
    },
    volunteerAchieved() {
      var achieved = 0
      for (let index = 0; index < this.goals.length; index++) {
        if (this.goals[index].type === 'volunteered') {
          achieved = this.goals[index].achieved
        }
      }
      return achieved
    },
    donationAchieved() {
      var achieved = 0
      for (let index = 0; index < this.goals.length; index++) {
        if (this.goals[index].type === 'donation') {
          achieved = this.goals[index].achieved
        }
      }
      return achieved
    },
    kyndnessAchieved() {
      var achieved = 0
      for (let index = 0; index < this.goals.length; index++) {
        if (this.goals[index].type === 'kyndness') {
          achieved = this.goals[index].achieved
        }
      }
      return achieved
    },
    gratitudeAchieved() {
      var achieved = 0
      for (let index = 0; index < this.goals.length; index++) {
        if (this.goals[index].type === 'gratitude') {
          achieved = this.goals[index].achieved
        }
      }
      return achieved
    },
  },
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    saveUserEdits() {
      this.saveButtonText = 'Loading...'
      var data = {
        name: this.userName,
        email: this.userEmail,
      }
      if (this.editingPassword) {
        this.$v.$touch()
        // if its still pending or an error is returned do not submit
        if (this.$v.$pending || this.$v.$error) return
        // to form submit after this

        data.password = this.userCurrentPassword
        data.new_password = this.userNewPassword
        data.verify_password = this.userConfirmNewPassword
      }
      if (this.croppedImage) {
        data.image_url = this.croppedImage
      }
      store
        .dispatch('auth/updateUser', {
          data: data,
        })
        .then((response) => {
          this.editingName = false
          this.editingEmail = false
          this.editingPassword = false
          this.$emit('close')
          this.saveButtonText = 'Save'
        })
    },
    saveUserGoals() {
      var goals = this.goals
      var data = {
        goals: JSON.stringify(goals),
      }
      store
        .dispatch('auth/updateUser', {
          data: data,
        })
        .then((response) => {
          this.editingName = false
        })
    },
    editName() {
      this.editingName = true
    },
    saveName() {
      this.editingName = false
    },
    cancelName() {
      this.userEmail = this.user.email
      this.editingName = false
    },
    editEmail() {
      this.editingEmail = true
    },
    saveEmail() {
      this.editingEmail = false
    },
    cancelEmail() {
      this.userEmail = this.user.email
      this.editingEmail = false
    },
    clickOnFileUpload() {
      this.$refs.file.click()
    },
    resetChanges() {
      this.userEmail = this.user.email
      this.editingName = false
      this.userEmail = this.user.email
      this.editingEmail = false
      this.userPhone = this.user.phone
      this.editingPhone = false
      this.userPhoto = this.user.image_url
      this.editingPassword = false
      this.$emit('close')
    },
    resetUserGoals() {},
    uploadFiles(event) {
      var input = event.target
      if (input.files && input.files.length > 0) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.toCropImage = {
            original: e.target.result,
            cropped: null,
          }
        }
        reader.readAsDataURL(input.files[0])
        this.visibleImageCropper = true
      }
    },
    crop() {
      const { coordinates, canvas } = this.$refs.cropper.getResult()
      this.coordinates = coordinates
      this.toCropImage.cropped = canvas.toDataURL()
    },
    onClose() {
      this.visibleImageCropper = false
    },
    finishCropping() {
      this.crop()
      this.croppedImage = this.toCropImage.cropped
      this.userPhoto = this.croppedImage
      this.visibleImageCropper = false
    },
    editPassword() {
      this.editingPassword = !this.editingPassword
    },
    leaveHub(hubId) {
      store
        .dispatch('auth/leaveHub', {
          hubId: hubId,
        })
        .then((response) => {})
    },
    leaveOpenGroup(groupId) {
      store
        .dispatch('auth/leaveOpenGroup', {
          groupId: groupId,
        })
        .then((response) => {})
    },
    selectedTab() {
      if (this.$route.meta.tmp.showUserProfile) {
        return 1
      } else {
        return 0
      }
    },
    acceptInvite(invite) {
      store
        .dispatch('companies/acceptHubInvite', {
          requestId: invite.id,
        })
        .then((response) => {
          if (response.message === 'success') {
            store
              .dispatch('auth/acceptedHubInvite', {
                invite: invite,
              })
              .then((response) => {
                this.$router.push({
                  name: 'company',
                  params: { companyId: invite.company_id },
                })
              })
          }
        })
    },
    rejectInvite(invite) {
      store
        .dispatch('companies/rejectHubInvite', {
          requestId: invite.id,
        })
        .then((response) => {
          if (response.message === 'success') {
            store
              .dispatch('auth/rejectedHubInvite', {
                invite: invite,
              })
              .then((response) => {})
          }
        })
    },
  },
}
</script>

<template>
  <div>
    <h3 class="block pb-6 italic font-brandon text-blue-darker text-35xl"
      >EDIT USER</h3
    >
    <Tabs :active-tab="selectedTab()">
      <Tab
        title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21.044 24.049" class="inline-block align-middle"><g id="Group_244" data-name="Group 244" transform="translate(-453.062 -37.45)"><path id="Path_109" data-name="Path 109" d="M463.593,50.506a6.528,6.528,0,1,0-6.529-6.528A6.546,6.546,0,0,0,463.593,50.506Zm-5.133-6.528a5.139,5.139,0,0,1,5.133-5.133l.133,0a5.135,5.135,0,1,1-5.266,5.135Z" fill="#00638A"/><path id="Path_110" data-name="Path 110" d="M463.584,50.727a10.534,10.534,0,0,0-10.522,10.522v.25h1.4v-.25a9.139,9.139,0,0,1,9.123-9.123h0a9.126,9.126,0,0,1,9.127,9.123v.25h1.15v-.25h.24A10.534,10.534,0,0,0,463.584,50.727Z" fill="#00638A"/></g></svg> <span class="align-middle">Profile</span>'
      >
        <div class="flex justify-between">
          <div class="w-7/12">
            <div class="mb-7">
              <label for="name" class="text-base text-gray-light">Name:</label>
              <span
                v-show="!editingName"
                class="ml-5 text-sm cursor-pointer text-blue"
                @click="editName"
                >Edit</span
              >
              <span
                v-show="editingName"
                class="ml-5 text-sm cursor-pointer text-blue"
                @click="saveName"
                >Save</span
              >
              <span
                v-show="editingName"
                class="ml-5 text-sm cursor-pointer text-blue"
                @click="cancelName"
                >Cancel</span
              >
              <br />
              <div v-show="!editingName" class="text-3xl text-blue-darker">{{
                userName
              }}</div>
              <input
                v-show="editingName"
                v-model="userName"
                class="w-10/12 input"
                type="text"
                name="name"
              />
            </div>
            <div class="mb-7">
              <label for="email" class="text-base text-gray-light"
                >Email:</label
              >
              <span
                v-show="!editingEmail"
                class="ml-5 text-sm cursor-pointer text-blue"
                @click="editEmail"
                >Edit</span
              >
              <span
                v-show="editingEmail"
                class="ml-5 text-sm cursor-pointer text-blue"
                @click="saveEmail"
                >Save</span
              >
              <span
                v-show="editingEmail"
                class="ml-5 text-sm cursor-pointer text-blue"
                @click="cancelEmail"
                >Cancel</span
              >
              <br />
              <div v-show="!editingEmail" class="text-3xl text-blue-darker">{{
                userEmail
              }}</div>
              <input
                v-show="editingEmail"
                v-model="userEmail"
                class="w-10/12 input"
                type="email"
                name="email"
              />
            </div>
            <div class="mb-7">
              <label for="phone" class="text-base text-gray-light"
                >Phone:</label
              >
              <router-link
                :to="{ name: 'verify-phone' }"
                class="ml-5 text-sm cursor-pointer text-blue"
                >Edit</router-link
              ><br />
              <div v-show="!editingPhone" class="text-3xl text-blue-darker"
                >{{ userCountryPrefix }} - {{ userPhone }}</div
              >
            </div>

            <div v-show="editingPassword" class="w-10/12 space-y-6">
              <div>
                <label class="block mb-2 text-base text-gray-light">
                  Current Password:
                </label>
                <BaseInputText
                  v-model="userCurrentPassword"
                  :vuelidate="$v.userCurrentPassword"
                  required
                  type="password"
                />
              </div>
              <div>
                <label class="block mb-2 text-base text-gray-light">
                  New Password:
                </label>
                <BaseInputText
                  v-model="userNewPassword"
                  :vuelidate="$v.userNewPassword"
                  type="password"
                  required
                >
                  <template v-slot:errors>
                    <p
                      v-if="
                        $v.userNewPassword.required &&
                          !$v.userNewPassword.notCurrentPassword
                      "
                    >
                      New password must be different.
                    </p>
                  </template>
                </BaseInputText>
              </div>
              <div>
                <label class="block mb-2 text-base text-gray-light">
                  Confirm New Password:
                </label>
                <BaseInputText
                  v-model="userConfirmNewPassword"
                  :vuelidate="$v.userConfirmNewPassword"
                  type="password"
                  required
                >
                  <template v-slot:errors>
                    <p
                      v-if="
                        $v.userConfirmNewPassword.required &&
                          !$v.userConfirmNewPassword.sameAsNewPassword
                      "
                    >
                      Passwords must be identical.
                    </p>
                  </template>
                </BaseInputText>
              </div>
            </div>

            <div class="">
              <button
                class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
                @click="saveUserEdits"
                >{{ saveButtonText }}</button
              >
              <button
                class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
                @click="resetChanges"
                >Cancel</button
              >
            </div>
          </div>
          <div class="w-5/12">
            <div class="mb-11">
              <label for="name" class="text-base text-gray-light"
                >Avatar:</label
              >
              <br />
              <div class="flex">
                <div class="relative w-6/12">
                  <img
                    :src="userPhoto"
                    class="mt-3.5 rounded-full h-36 w-36 inline-block "
                  />
                  <div
                    class="border border-blue-default rounded-full absolute bottom-0 right-0 p-2.5 bg-white w-10 h-10 cursor-pointer"
                    @click="clickOnFileUpload"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.494"
                      height="16.611"
                      viewBox="0 0 19.494 16.611"
                    >
                      <g
                        id="Group_336"
                        data-name="Group 336"
                        transform="translate(-3 -2)"
                      >
                        <path
                          id="Path_180"
                          data-name="Path 180"
                          d="M19.774,18.611H5.72A2.72,2.72,0,0,1,3,15.891V8.347a2.72,2.72,0,0,1,2.72-2.72H7.08l.453-1.655A3.239,3.239,0,0,1,10.707,2h4.08a3.239,3.239,0,0,1,3.173,1.972l.453,1.655h1.36a2.72,2.72,0,0,1,2.72,2.72v7.544A2.72,2.72,0,0,1,19.774,18.611ZM5.72,6.534A1.813,1.813,0,0,0,3.907,8.347v7.544A1.813,1.813,0,0,0,5.72,17.7H19.774a1.813,1.813,0,0,0,1.813-1.813V8.347a1.813,1.813,0,0,0-1.813-1.813H18.06a.454.454,0,0,1-.453-.331l-.553-1.986a2.323,2.323,0,0,0-2.267-1.31h-4.08A2.323,2.323,0,0,0,8.44,4.217L7.892,6.2a.454.454,0,0,1-.453.331Z"
                        />
                        <path
                          id="Path_181"
                          data-name="Path 181"
                          d="M19.08,23.16a4.08,4.08,0,1,1,4.08-4.08,4.08,4.08,0,0,1-4.08,4.08Zm0-7.254a3.173,3.173,0,1,0,3.173,3.173A3.173,3.173,0,0,0,19.08,15.907Z"
                          transform="translate(-6.56 -7.106)"
                        />
                        <path
                          id="Path_182"
                          data-name="Path 182"
                          d="M35.36,16.72a1.36,1.36,0,1,1,1.36-1.36A1.36,1.36,0,0,1,35.36,16.72Zm0-1.813a.453.453,0,1,0,.453.453A.454.454,0,0,0,35.36,14.907Z"
                          transform="translate(-16.946 -6.56)"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
                <div class="relative w-5/12">
                  <button
                    class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mb-1 absolute bottom-0"
                    @click="clickOnFileUpload"
                    >Upload</button
                  >
                  <input
                    ref="file"
                    type="file"
                    class="hidden"
                    multiple
                    accept="image/*,video/*"
                    @change="uploadFiles($event)"
                  />
                  <BaseModalWindow
                    modalcls="w-user-edit bg-white rounded-xl mx-auto px-11 shadow-box relative z-40 left-0 flex justify-between overflow-hidden"
                    :visible="visibleImageCropper"
                    @close="onClose"
                  >
                    <template v-slot:body>
                      <div class="w-full mx-auto mt-12 mb-5">
                        <div class="">
                          <Cropper
                            v-if="toCropImage"
                            ref="cropper"
                            :stencil-props="{
                              aspectRatio: 1 / 1,
                            }"
                            classname="w-full"
                            :src="toCropImage.original"
                          />
                        </div>

                        <div class="mt-3">
                          <button
                            class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
                            @click="finishCropping"
                            >Done</button
                          >
                        </div>
                      </div>
                    </template>
                  </BaseModalWindow>
                </div>
              </div>
            </div>
            <div class="">
              <router-link
                :to="{ name: 'user-page', params: { userId: user.id } }"
                class="inline-block h-12 mr-2 text-right button primary-button"
                >View Profile</router-link
              >

              <button
                class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
                @click="editPassword"
                >Change Password</button
              >
            </div>
          </div>
        </div>
      </Tab>
      <Tab
        title='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 981.46" width="29" height="29" fill="#00638A" class="inline-block align-middle"><title>Kyndhub_Hubs_Icon</title><path d="M979.53,132.29a75.57,75.57,0,0,0-54-26.42,78.93,78.93,0,0,0-83.94,72h0A64.07,64.07,0,0,0,844,204.35L599.05,346a153.26,153.26,0,0,0-32.4-30,132.48,132.48,0,0,0-60-22.81V163.67a78.58,78.58,0,1,0-65.19-10.91h0a86.82,86.82,0,0,0,24,10.82V293.24A140.87,140.87,0,0,0,373,346.08L154.71,220a78.4,78.4,0,0,0-6-49.15,79.77,79.77,0,0,0-44.48-39.7,75,75,0,0,0-60,3.61,79.8,79.8,0,0,0-39.57,44.4,75,75,0,0,0,3.61,60,79.82,79.82,0,0,0,44.4,39.62,93.61,93.61,0,0,0,25.24,4.79,66.57,66.57,0,0,0,33.63-8.4,100,100,0,0,0,25.19-19.21l217.4,124.86a131.43,131.43,0,0,0-7.21,80.45,170.17,170.17,0,0,0,7.21,26.43L229.14,559.71A79,79,0,0,0,94.65,608.87a77.84,77.84,0,0,0,72.54,82.79l.71,0h5.94a80.67,80.67,0,0,0,51.61-19.21A75.6,75.6,0,0,0,252,618.37h0A66.13,66.13,0,0,0,249.54,592l125-71.89a153.06,153.06,0,0,0,32.41,30,135.81,135.81,0,0,0,60,22.81V837a78.17,78.17,0,0,0-44.41,31.22,80,80,0,0,0,20.49,109.25,74.23,74.23,0,0,0,44.4,13.19,76.33,76.33,0,0,0,64.85-34.82,80,80,0,0,0-20.48-109.25h0a86.88,86.88,0,0,0-24-10.82V571.72c2.42,0,4.79-1.19,7.21-1.19a144.33,144.33,0,0,0,85.25-51.62l162.09,93.65a77.84,77.84,0,0,0,49.16,94.83,93.33,93.33,0,0,0,25.19,4.79,66.7,66.7,0,0,0,33.64-8.39A79.86,79.86,0,0,0,910,659.38a75,75,0,0,0-3.61-60A79.82,79.82,0,0,0,862,559.75a75,75,0,0,0-60,3.61A71.08,71.08,0,0,0,780.32,579l-161-91.27a131.46,131.46,0,0,0,7.21-80.46,170.35,170.35,0,0,0-7.21-26.42L865.48,239.17A76,76,0,0,0,915.91,262h6a77.83,77.83,0,0,0,78-73.24A81.94,81.94,0,0,0,979.53,132.29ZM94.69,239.12A34.52,34.52,0,0,1,66,240.31,33.38,33.38,0,0,1,43,221a34.58,34.58,0,0,1-1.19-28.68,37.16,37.16,0,0,1,36-25.19,35.25,35.25,0,0,1,12,2.42,38.19,38.19,0,0,1,21.63,19.21,36.86,36.86,0,0,1-15.55,49.76c-.41.22-.83.43-1.25.63ZM211.16,617.31h0A42.93,42.93,0,0,1,198,643.73a38.94,38.94,0,0,1-27.61,9.59,43,43,0,0,1-26.42-13.19,39,39,0,0,1-9.58-27.61,38.22,38.22,0,0,1,38.42-36h2.42a42.92,42.92,0,0,1,26.42,13.19,35.73,35.73,0,0,1,9.55,27.65ZM454.85,66.25a38.84,38.84,0,1,1-.18.27ZM518.51,937.9a38.14,38.14,0,0,1-63.62-42,35.66,35.66,0,0,1,24-15.61c2.42,0,4.79-1.19,7.21-1.19a36.05,36.05,0,0,1,21.63,7.21h0a35.64,35.64,0,0,1,12.62,48.8C519.79,936.05,519.17,937,518.51,937.9ZM505.32,535.67a102.8,102.8,0,0,1-76.85-15.61,100.06,100.06,0,0,1-43.26-66,102.83,102.83,0,0,1,15.61-76.85,106.08,106.08,0,0,1,85.25-45.6,102.08,102.08,0,0,1,57.64,18,100,100,0,0,1,43.21,66,102.79,102.79,0,0,1-15.6,76.85,109.45,109.45,0,0,1-66,43.18Zm314.57,66a38.31,38.31,0,0,1,16.79-3.6,35.54,35.54,0,0,1,12,2.41,38.18,38.18,0,0,1,21.63,19.22,34.56,34.56,0,0,1,1.18,28.67A38.19,38.19,0,0,1,852.29,670a34.56,34.56,0,0,1-28.67,1.19A38.13,38.13,0,0,1,802,652a34.58,34.58,0,0,1-1.19-28.68,37.74,37.74,0,0,1,19.05-21.59ZM959.17,186.28a38.51,38.51,0,1,1-76.94-3.3c0-.5,0-1,.09-1.49h0a38.71,38.71,0,0,1,41-36,43,43,0,0,1,26.43,13.19,32.77,32.77,0,0,1,9.42,27.65Z" transform="translate(0 -9.27)"/></svg> <span class="align-middle">Business or school</span>'
      >
        <div class="">
          <p class="mb-7"
            >Here you can manage the business or school you belong to:</p
          >
          <div class="">
            <div v-if="defaultCompany" class="mb-2 text-blue-darker">
              Default business or school:
            </div>
            <div v-if="defaultCompany" class="mb-7">
              <div
                class="flex justify-between px-8 py-4 mb-2 -mx-8 bg-gray-lightest rounded-comments leading-125"
              >
                <router-link
                  :to="{
                    name: 'company',
                    params: { companyId: defaultCompany.id },
                  }"
                  class=""
                  ><img
                    :src="defaultCompany.image_url"
                    class="inline-block w-5 h-5 mr-2 rounded-full"
                  />
                  <span class="text-blue-darker">{{
                    defaultCompany.name
                  }}</span></router-link
                >
                <div class="flex text-sm text-blue">
                  <div
                    class="cursor-pointer"
                    @click="leaveHub(defaultCompany.id)"
                  >
                    <span class="ml-2">X</span> Leave Business or School
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="user.company_invites.length > 0"
              class="mb-2 text-blue-darker"
            >
              Invites:
            </div>
            <div class="mb-7">
              <div
                v-for="invite in user.company_invites"
                :key="invite.id"
                class="flex justify-between px-8 py-4 mb-2 -mx-8 bg-gray-lightest rounded-comments leading-125"
              >
                <span>
                  <img
                    :src="invite.company.image_url"
                    class="inline-block w-5 h-5 mr-2 rounded-full"
                  />
                  <span class="text-blue-darker">{{
                    invite.company.name
                  }}</span>
                </span>
                <div class="flex text-sm text-blue">
                  <div class="cursor-pointer" @click="acceptInvite(invite)">
                    <div
                      class="w-5 h-5 leading-normal text-gray text-center ml-2 text-l border border-gray-dark rounded-full relative"
                      ><span
                        class="absolute left-0 mt-1 leading-3 text-center w-full"
                        >✓</span
                      ></div
                    >
                  </div>
                  <div class="cursor-pointer" @click="rejectInvite(invite)">
                    <div
                      class="w-5 h-5 leading-normal text-gray text-center ml-2 text-l border border-gray-dark rounded-full relative"
                      ><span
                        class="absolute left-0 mt-1 leading-3 text-center w-full"
                        >X</span
                      ></div
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-if="defaultCompany" class="mb-2 text-blue-darker">
              Secondary business or school:
            </div>
            <div class="mb-2">
              <div
                v-for="company in companies"
                :key="company.id"
                class="flex justify-between px-8 py-4 mb-2 -mx-8 bg-gray-lightest rounded-comments leading-125"
              >
                <router-link
                  :to="{
                    name: 'company',
                    params: { companyId: company.id },
                  }"
                  class=""
                >
                  <img
                    :src="company.image_url"
                    class="inline-block w-5 h-5 mr-2 rounded-full"
                  />
                  <span class="text-blue-darker">{{ company.name }}</span>
                </router-link>
                <div class="flex text-sm text-blue">
                  <div class="cursor-pointer" @click="leaveHub(company.id)">
                    <span class="ml-2">X</span> Leave Business or School
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tab>
      <Tab
        title='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 896.11 1000" width="28" height="31" fill="#00638A" class="inline-block align-middle"><title>Kyndhub_Groups_Icon</title><path d="M857.9,580l-5.49-1.27V421.27l5.53-1.23a114.68,114.68,0,0,0,90.11-112.48,116.12,116.12,0,0,0-201.2-79.43l-3.85,4.1L609.58,155.14l1.31-5.2a145.3,145.3,0,0,0,5.41-33.39,116.5,116.5,0,0,0-233-.11v.11a89.39,89.39,0,0,0,5.16,32.77l2.09,5.61-133.5,77.34-3.85-4.1A116,116,0,1,0,142,420l5.49,1.27V578.69L142,580A116,116,0,1,0,253.21,771.83l3.85-4.1,133.09,77.13-1.31,5.2a145.3,145.3,0,0,0-5.41,33.39,116.5,116.5,0,0,0,233,.11v-.11a89.39,89.39,0,0,0-5.16-32.77l-2.09-5.61,133.66-77.46,3.85,4.09A116,116,0,1,0,857.9,579.84ZM832.83,231.78a74.59,74.59,0,0,1,74.51,74.51v.16a75.59,75.59,0,0,1-74.51,74.23,74.51,74.51,0,0,1,0-149ZM501.36,43.43a74.51,74.51,0,0,1,0,149,73.72,73.72,0,0,1-74.51-72.94c0-.52,0-1,0-1.57A74.59,74.59,0,0,1,501.36,43.43ZM96.77,307.56a74.51,74.51,0,1,1,74.51,74.55H171A75.58,75.58,0,0,1,96.77,307.56Zm73.12,459.35a74.51,74.51,0,1,1,74.51-74.59,74.51,74.51,0,0,1-74.51,74.59h0ZM501.36,956.53a74.52,74.52,0,0,1,0-149,73.73,73.73,0,0,1,74.51,73c0,.52,0,1,0,1.57a74.6,74.6,0,0,1-74.51,74.55Zm215-264.21a82.16,82.16,0,0,0,5,30.93l2.5,5.77-134,77.71-3.85-4.1a115.31,115.31,0,0,0-162.94-6.52q-3.39,3.14-6.52,6.52l-3.85,4.1L279.67,729.59l1.31-5.16a134.55,134.55,0,0,0,5.41-32A116.61,116.61,0,0,0,196.27,580l-5.49-1.27V421.31l5.49-1.27a116.61,116.61,0,0,0,90.12-112.48,82.13,82.13,0,0,0-5-30.93l-2.5-5.77L413,193.27l3.85,4.1a115.31,115.31,0,0,0,162.94,6.52q3.39-3.13,6.52-6.52l3.86-4.1L723,270.41l-1.31,5.16a134.55,134.55,0,0,0-5.41,32A116.61,116.61,0,0,0,806.41,420l5.49,1.27V578.69L806.41,580A116.62,116.62,0,0,0,716.33,692.32Zm115.1,74.51a74.51,74.51,0,1,1,0-149h.25A75.57,75.57,0,0,1,906,692.32,74.6,74.6,0,0,1,831.43,767Z" transform="translate(-51.94 0)"/></svg> <span class="align-middle">Groups</span>'
      >
        <div class="">
          <p class="mb-7">Here you can manage the groups you belong to:</p>
          <div class="">
            <div v-if="user.open_groups.length > 0" class="mb-2">
              <div
                v-for="group in user.open_groups"
                :key="group.id"
                class="flex justify-between px-8 py-4 mb-2 -mx-8 bg-gray-lightest rounded-comments leading-125"
              >
                <router-link
                  :to="{
                    name: 'group',
                    params: {
                      companyId: group.company_id,
                      groupId: group.id,
                    },
                  }"
                  class=""
                >
                  <img
                    :src="group.image_url"
                    class="inline-block w-5 h-5 mr-2 rounded-full"
                  />
                  <span class="text-blue-darker">{{ group.name }}</span>
                </router-link>
                <div class="flex text-sm text-blue">
                  <div class="cursor-pointer" @click="leaveOpenGroup(group.id)">
                    <span class="ml-2">X</span> Leave Group
                  </div>
                </div>
              </div>
            </div>
            <div v-if="user.open_groups.length === 0" class="mb-2">
              You are not currently a member of any groups. Please see the
              Groups section on the left-hand navigation panel to find the right
              Group for you
            </div>
          </div>
        </div>
      </Tab>
      <Tab
        title='<svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 24.861 25.805" fill="#069BD7" class="inline-block align-middle"><path id="Path_129" data-name="Path 129" d="M38.27,10.678l-12.545.031V7.5H13.41V33.305H14.5V20.224H24.636v2.925H38.271l-3.842-6.236ZM24.636,19.135H14.5V8.589H24.636ZM36.3,22.059H25.725V11.8H36.306l-3.172,5.117Z" transform="translate(-13.41 -7.5)" fill="#069BD7"/></svg> <span class="align-middle">Update Goals</span>'
      >
        <div class="">
          <p class="mb-7">My Community Investment Goals:</p>
          <div class="flex justify-between">
            <div class="w-7/12 mr-6">
              <div class="mb-5 text-blue-darker">
                Set Your Goals For The Year
              </div>
              <div
                class="rounded-2xl bg-blue-default text-sml text-white flex justify-between px-3.5 py-2.5 leading-looser mb-5 mr-6"
              >
                <span class="italic font-brandon">HOURS:</span>
                <input
                  v-model="volunteerGoal"
                  type="text"
                  class="w-5/12 bg-white input leading-paragraph"
                />
              </div>
              <div
                class="rounded-2xl bg-blue-default text-sml text-white flex justify-between px-3.5 py-2.5 leading-looser mb-5 mr-6"
              >
                <span class="italic font-brandon">PENCIL POSITIVES:</span>
                <input
                  v-model="kyndnessGoal"
                  type="text"
                  class="w-5/12 bg-white input leading-paragraph"
                />
              </div>
              <div
                class="rounded-2xl bg-blue-default text-sml text-white flex justify-between px-3.5 py-2.5 leading-looser mb-5 mr-6"
              >
                <span class="italic font-brandon">DONATION:</span>
                <input
                  v-model="donationGoal"
                  type="text"
                  class="w-5/12 bg-white input leading-paragraph"
                />
              </div>
              <div
                class="rounded-2xl bg-blue-default text-sml text-white flex justify-between px-3.5 py-2.5 leading-looser mb-5 mr-6"
              >
                <span class="italic font-brandon">GRATITUDE:</span>
                <input
                  v-model="gratitudeGoal"
                  type="text"
                  class="w-5/12 bg-white input leading-paragraph"
                />
              </div>
              <div class="">
                <button
                  class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
                  @click="saveUserGoals"
                  >Save</button
                >
                <button
                  class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
                  @click="resetUserGoals"
                  >Reset</button
                >
              </div>
            </div>
            <div class="w-1/2">
              <div class="mb-5 text-black">
                My Current Community Investment:
              </div>
              <div
                class="flex mt-5 h-13 border-l-5 border-volunteer_red leading-2xl"
              >
                <div class="pl-3.5 text-4xl text-blue-darker">
                  {{ numberWithCommas(volunteerAchieved) }}
                </div>
                <div class="pl-3.5 text-basel text-blue-darker leading-16">
                  Volunteer Hours
                </div>
              </div>
              <div
                class="flex mt-5 h-13 border-l-5 border-aok_green leading-2xl"
              >
                <div class="pl-3.5 text-4xl text-blue-darker">
                  {{ numberWithCommas(kyndnessAchieved) }}
                </div>
                <div class="pl-3.5 text-basel text-blue-darker leading-16">
                  PENCIL Positives
                </div>
              </div>
              <div
                class="flex mt-5 h-13 border-l-5 border-donation leading-2xl"
              >
                <div class="pl-3.5 text-4xl text-blue-darker">
                  {{ numberWithCommas(donationAchieved) }}
                </div>
                <div class="pl-3.5 text-basel text-blue-darker leading-16">
                  Donation
                </div>
              </div>
              <div
                class="flex mt-5 h-13 border-l-5 border-gratitude_purple leading-2xl"
              >
                <div class="pl-3.5 text-4xl text-blue-darker">
                  {{ numberWithCommas(gratitudeAchieved) }}
                </div>
                <div class="pl-3.5 text-basel text-blue-darker leading-16">
                  Graditude
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tab>
    </Tabs>
  </div>
</template>
